import { render, staticRenderFns } from "./terms-of-agreements-short.vue?vue&type=template&id=07ef70aa"
import script from "./terms-of-agreements-short.vue?vue&type=script&lang=js"
export * from "./terms-of-agreements-short.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports